import { useContext } from 'react';
import type { UiContextType } from './UiContext';
import { UiContext } from './UiContext';

export function useUiContext() {
  const {
    dateFnsLocale,
    isUnauthorizedDialogVisible,
    showUnauthorizedDialog,
    setIsSearchFilterInProgress,
    isSearchFilterInProgress
  } = useContext(UiContext) as UiContextType;
  return {
    dateFnsLocale,
    showUnauthorizedDialog,
    isUnauthorizedDialogVisible,
    setIsSearchFilterInProgress,
    isSearchFilterInProgress
  };
}
